import { useAuthStore } from '../store/auth'

/**
 * Fetch a file from /api/files/* with the auth token attached,
 * then return a blob URL that can be used in <img>, <iframe>, etc.
 */
export async function fetchAuthenticatedFile(path: string): Promise<string> {
  const token = useAuthStore.getState().token
  const res = await fetch(path, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
  if (!res.ok) throw new Error(`Failed to load file: ${res.status}`)
  const blob = await res.blob()
  return URL.createObjectURL(blob)
}
